import { motion } from 'framer-motion';
import { Heart, Instagram, Facebook, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_petclean/artifacts/l97b9wi1_587275905_18091423295301075_4208672925189871598_n-Photoroom.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="bg-gray-900 text-white pt-16 pb-8 relative overflow-hidden"
      data-testid="footer"
    >
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-2 bg-yellow-500" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Logo & Description */}
          <div>
            <img 
              src={LOGO_URL} 
              alt="Pet Guardiões" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-400 leading-relaxed mb-4">
              Cuidamos do seu patudo com amor, calma e profissionalismo. 
              Banho e tosquia em Setúbal, num ambiente seguro e acolhedor.
            </p>
            <div className="flex gap-3">
              <motion.a
                href="https://www.instagram.com/petguardioes.setubal/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-xl flex items-center justify-center hover:bg-yellow-500 transition-colors group"
                whileHover={{ scale: 1.1 }}
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5 text-gray-400 group-hover:text-gray-900" />
              </motion.a>
              <motion.a
                href="https://www.facebook.com/petguardioes.setubal/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-xl flex items-center justify-center hover:bg-yellow-500 transition-colors group"
                whileHover={{ scale: 1.1 }}
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5 text-gray-400 group-hover:text-gray-900" />
              </motion.a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-nunito font-bold text-lg mb-4">Links Rápidos</h4>
            <ul className="space-y-3">
              {[
                { label: 'Início', href: '#inicio' },
                { label: 'Serviços', href: '#servicos' },
                { label: 'Agendamento', href: '#agendamento' },
                { label: 'Galeria', href: '#galeria' },
                { label: 'Avaliações', href: '#avaliacoes' },
                { label: 'Contactos', href: '#contactos' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-yellow-500 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-nunito font-bold text-lg mb-4">Contactos</h4>
            <div className="space-y-4">
              <div>
                <p className="text-gray-400">Rua Dom Pedro Fernandes Sardinha, 66</p>
                <p className="text-gray-400">2910-633 Setúbal, Portugal</p>
              </div>
              <div>
                <p className="text-gray-400">Terça a Sábado: 10h00 - 18h00</p>
                <p className="text-gray-500 text-sm">Segunda-feira: encerrado</p>
              </div>
              <a
                href="tel:+351913918967"
                className="inline-flex items-center gap-2 text-yellow-500 hover:text-yellow-400 transition-colors"
              >
                <Phone className="w-4 h-4" />
                +351 913 918 967
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm text-center md:text-left">
            © {currentYear} Pet Guardiões – Banho & Tosquia. Todos os direitos reservados.
          </p>
          <p className="text-gray-500 text-sm flex items-center gap-1">
            Feito com <Heart className="w-4 h-4 text-red-500 fill-red-500" /> em Setúbal
          </p>
        </div>
      </div>
    </footer>
  );
};
